const Container = (props) => {
  return (
    <div className={`container mx-auto px-5 ${props.className ? props.className : ""} ${props.type==="fullscreen" ? "max-w-full bg-slate-100 mb-10" : ""} ${props.zIndex ? 'z-'+props.zIndex : ''}`}>{props.children}</div> 
  );
};

export default Container;